export const environment = {
  production: false,
  apiUrl: 'https://devadmin.servicegalaxy.com:3001/',
  baseURL: 'https://devsuperadmin.servicegalaxy.com/#/client/client-profile/',
  CRYPTO_UNSUBSSCRIBE_SIGNATURE: 'sdfgencrypt098978878hjjkiuyo7890',
  CRYPTO_MATCH_SIGN: 'qwerdecrypt567865432hgfdsa0987u',
  valorWebHook: 'https://stagingadmin.servicegalaxy.com/v1/client/valorWebhook',
  country: 'IN',
  googleMapsApiKey: "AIzaSyC2UyybrDbece03B9gLCOc1mFlRIrG7bgk",
  calKEY: '0285120952-fcs-1681488481',
  googleKey: "AIzaSyC2UyybrDbece03B9gLCOc1mFlRIrG7bgk",
  firebase: {                                                                                                                                   
    apiKey: "AIzaSyBPLQzzcxnw4qKYV7WmkCKSy6AnnF3gMIk",
    authDomain: "service-galaxy.firebaseapp.com",
    databaseURL: "https://service-galaxy-default-rtdb.firebaseio.com",
    projectId: "service-galaxy",
    storageBucket: "service-galaxy.firebasestorage.app",
    messagingSenderId: "466475764062",
    appId: "1:466475764062:web:73dc8cc4354c54dd9467cf",
    measurementId: "G-JVZL9QCTSJ"
  },
  meetingConfig: {
    sdkKey: 'ikI41GHPAriAjMHhDEx9iRYmTeBrWv7UsGGa',
    CLIENT_ID: 'pQu905JvTIORykAIV8HcPw',
    CLIENT_SECRET: '5QLihzRoykfPg4AVKtpykR17hcVKxOdS'
  },
  bucketurl: 'https://service-galaxy.s3.us-east-2.amazonaws.com',
  bucketname: "service-galaxy-dev", 
  calendly: 'https://calendly.com/servicegalaxy-info/onboarding-schedule',
  newRelic: {
    accountID: '6883839',
    trustKey: '6883839',
    agentID: '1589108982',
    licenseKey: 'NRJS-c165fd9d98cf0f5c220',
    applicationID: '1589108982',
  }
};